import React from 'react'
import { connect } from 'react-redux'
import {
  Fade,
} from '@material-ui/core'

import { StdCard } from 'components'
import TableDetail from '../TableDetail'
import PRBudget from '../PRBudget'

import { ProcurementBody } from 'routes/ProcurementSystem/styled'

const Detail = props => {
  const { 
    isCreate=false, 
    isEdit=false,
    valueForm
  } = props
  return (
    <Fade in={true} timeout={1000}>
      <ProcurementBody>
          <StdCard title='Detail Information'>
            <TableDetail isCreate={isCreate} isEdit={isEdit}/>
            <PRBudget isCreate={isCreate} valueForm={valueForm} isEdit={isEdit}/>
          </StdCard>
      </ProcurementBody>
    </Fade>
  )
}

const mapStateToProps = (state, props) => {
  return {
  }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(Detail)
